const routeNames = {
  // Global editor
  GlobalEditor: 'GlobalEditor',
  AddGlobalChannel: 'AddGlobalChannel',
  GlobalChannel: 'GlobalChannel',
  GlobalPresetRange: 'GlobalPresetRange',
  GlobalPreset: 'GlobalPreset',
  // Local editor
  Mode: 'Mode',
  ManageModes: 'ManageModes',
  AddLocalChannel: 'AddLocalChannel',
  LocalChannel: 'LocalChannel',
  LocalPresetRange: 'LocalPresetRange',
  LocalPreset: 'LocalPreset',
  // Other
  Import: 'Import',
  Create: 'Create',
  Profile: 'Profile',
  Properties: 'Properties',
  Content: 'Content',
  Modes: 'Modes',
  Home: 'Home',
  SSORedirect: 'SSORedirect',
  Error: 'Error',
  // Distribute
  DistributeGlobalPresets: 'DistributeGlobalPresets',
  DistributeLocalPresets: 'DistributeLocalPresets',
  // Add global
  AddGlobalPreset: 'AddGlobalPreset',
  AddGlobalPresetTag: 'AddGlobalPresetTag',
  // Add local
  AddLocalPreset: 'AddLocalPreset',
  AddLocalPresetTag: 'AddLocalPresetTag',
  // Replace global
  ReplaceGlobalPreset: 'ReplaceGlobalPreset',
  ReplaceGlobalPresetTag: 'ReplaceGlobalPresetTag',
  // Replace local
  ReplaceLocalPreset: 'ReplaceLocalPreset',
  ReplaceLocalPresetTag: 'ReplaceLocalPresetTag',
}

export default routeNames
